<template lang="pug" src="./templates/JobCareerList.pug"></template>

<script>
import { RepositoryFactory } from '../../repositoryFactory';
import notify from '../notify';

import 'swiper/css/swiper.css';

const JobCareerRepository = RepositoryFactory.get('jobCareer');

export default {
  data() {
    return {
      jobs: [],
    };
  },
  created() {
    this.get();
  },
  methods: {
    async get() {
      try {
        const { data } = await JobCareerRepository.get();
        this.jobs = data;
      } catch (e) {
        notify.errors(this, e);
      }
    },
  },
};
</script>
